import { render, staticRenderFns } from "./Authentication.vue?vue&type=template&id=64413831&scoped=true"
import script from "./Authentication.vue?vue&type=script&lang=js"
export * from "./Authentication.vue?vue&type=script&lang=js"
import style0 from "./Authentication.vue?vue&type=style&index=0&id=64413831&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64413831",
  null
  
)

export default component.exports